import React ,{useState,useEffect} from 'react';
import styled from 'styled-components';
import Modal_bg from './Modal_bg';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';


// 하단 모달창 공통소스 (내용 여러개)
export default function Bottom_Modal_var3({setModalShow, modalShow ,modalOption,activeIndex , clickEventList ,currentPostIndex , setModalOption}) {
    const userInfo = useSelector(state=>{ return state.userInfo});
    
    const comparePath = (path) =>{
        return window.location.pathname.includes(path);
    }
    
    const modalStateList = {
        'filter': [{subtitle:"전체보기"},{subtitle:"자유글"},{subtitle:"정보공유" ,active :true, color:"#ffa700"},{subtitle:"가입인사"},{subtitle:"후기"}] ,
        'editUser': [{subtitle:"글수정",   path: `/${comparePath("group") ?"CommunityWrite" : "CampaignpostWrite"}/${currentPostIndex}`},{subtitle:"삭제"}],
        'editAdmin': [{subtitle:"핀 고정" ,active :true},{subtitle:"삭제"}],
        'editAdminSelf': [{subtitle:"핀 고정" ,active :true, color:"#ffa700"},{subtitle:"글수정",path:`/CommunityWrite/${currentPostIndex}`},{subtitle:"삭제"}],
        'routine': [{subtitle:"루틴 수정",path:`/routine/${currentPostIndex}/update`},{subtitle:"루틴 삭제",active :true, color:"#de0000"}],
        'postChange': [{subtitle:"글수정", path:`/${comparePath("group") ?"CommunityWrite" : "CampaignpostWrite"}/${currentPostIndex}`},{subtitle:"삭제"}],
        'commDel': [{subtitle:"삭제",active :true, color:"#de0000"}],
        'todoDel': [{subtitle:"삭제",active :true, color:"#de0000"}],
        'forcedExit': [{subtitle:"강제퇴장",active :true, color:"#de0000"}],
        'pictureDel': [{subtitle:"사진삭제",active :true, color:"#de0000"}],
        'friendcancel': [{subtitle:"친구취소",active :true, color:"#de0000"}],
        'requestCancel': [{subtitle:"요청취소",active :true, color:"#de0000"}],
    };

    return (
        // show 일때는 div(모달창)이 보여지고 아닐때는 null(안보임)
        modalShow ?
        <div>
            <Modal_bg background={"rgba(0, 0, 0, 0.6)"}/>
            <ModalTxtZone>
                <ModalTxt2List>
                {
                    modalStateList[modalOption] ? 
                        modalStateList[modalOption].map((value,index)=>{
                                let modalLinkList = [];
                                if(value.path)
                                {
                                    modalLinkList.push(
                                    <Link key={`bottom-modal-btn-index-${index}`} to={value.path}>
                                        <ModalTxt2>
                                            <ModalTxtBt 
                                                onClick={clickEventList ? clickEventList[index] : null} 
                                                color={
                                                    activeIndex != null ?
                                                    activeIndex == index ? "#ffa700" : "#4e4e4e"
                                                    :
                                                    value.active? value.color : "#4e4e4e"
                                                }
                                            >
                                            {value.subtitle}
                                            </ModalTxtBt>
                                        </ModalTxt2>
                                    </Link>);
                                }
                                else
                                {
                                    modalLinkList.push(
                                    <span key={`bottom-modal-btn-index-${index}`}>
                                        <ModalTxt2>
                                            <ModalTxtBt 
                                                onClick={clickEventList ? clickEventList[index] : null} 
                                                color={
                                                    activeIndex != null ?
                                                    activeIndex == index ? "#ffa700" : "#4e4e4e"
                                                    :
                                                    value.active? value.color : "#4e4e4e"
                                                }
                                            >
                                            {value.subtitle}
                                            </ModalTxtBt>
                                        </ModalTxt2>
                                    </span>
                                    );
                                }
                                return (
                                    modalLinkList
                                )
                        })
                    :
                    null
                }   
                </ModalTxt2List>
                <ModalTxt>
                    <ModalTxtBt onClick={()=>{setModalOption(""); setModalShow(false);}} style={{color:"#008aff"}}>{"취소"}</ModalTxtBt>
                </ModalTxt>
            </ModalTxtZone>
        </div>
        :
        null
    )
}


const ModalTxtZone = styled.div`
    position: fixed;
    bottom: 23px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 500;
`
const ModalTxt = styled.p` 
    font-size: calc(100vw*(20/375));
    line-height: 1.2;
    letter-spacing: -0.48px;
    text-align: center;
    width:  calc(100vw*(346/375));
    height:  calc(100vw*(56/375));
    border-radius:  calc(100vw*(10/375));
    -webkit-backdrop-filter: blur( calc(100vw*(20/375)););
    backdrop-filter: blur( calc(100vw*(20/375)););
    background-color: #ffffff;
    margin-top:calc(100vw*(9/375));
`
const ModalTxt2List = styled.ul`
    border-radius:  calc(100vw*(10/375));
    overflow:hidden;
`
const ModalTxt2 = styled.li`
    border-bottom: calc(100vw*(1/375)) solid #d5d5d5; 
    font-size: calc(100vw*(20/375));
    line-height: 1.2;
    letter-spacing: -0.48px;
    text-align: center;
    width:  calc(100vw*(346/375));
    height:  calc(100vw*(56/375));
    
    -webkit-backdrop-filter: blur( calc(100vw*(20/375)););
    backdrop-filter: blur( calc(100vw*(20/375)););
    background-color: #ffffff;
`
const ModalTxtBt = styled.button`
    width: 100%;
    height: 100%;
    color:${({color})=>color};
`
